import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Mail, TrendingUp } from 'lucide-react';
import { siteConfig } from '../../config/site';

const steps = [
  {
    icon: MapPin,
    title: 'Marcá tu lote',
    desc: `Buscá tu campo y dibujá un lote en el mapa o subí un archivo KML/KMZ del lote. Hasta ${siteConfig.freeHa} ha gratis.`,
  },
  {
    icon: Mail,
    title: 'Recibí el análisis de productividad',
    desc: 'Te enviamos un PDF con el mapa de ambientes y la cantidad de ha por cada zona de productividad.',
  },
  {
    icon: TrendingUp,
    title: 'Optimizá decisiones',
    desc: 'Usá la ambientación para prescribir siembra y fertilización variable gratis desde SpecifiC.',
  },
];

export function HowItWorksSection() {
  return (
    <section id={siteConfig.anchors.howItWorks} className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-wide text-brand-accent">Cómo funciona</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-brand-dark md:text-4xl">
            Tres pasos. Menos de 1 minuto.
          </h2>
          <p className="mt-3 text-brand-earth">Simple, guiado y pensado para pasar a la acción.</p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="relative rounded-2xl border border-brand-dark/5 bg-surface p-6 shadow-card"
              >
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-accent/15 text-brand-dark">
                  <Icon className="h-6 w-6" />
                </div>
                <span className="text-xs font-bold uppercase text-brand-accent">Paso {i + 1}</span>
                <h3 className="mt-1 font-display text-lg font-bold text-brand-dark">{step.title}</h3>
                <p className="mt-2 text-sm text-brand-earth">{step.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
